// TODO: set stamps from storage on load for use without internet connection

import Vue from 'vue';
import axios from 'axios';
import each from 'lodash/each';
import filter from 'lodash/filter';
import unionBy from 'lodash/unionBy';
import { BASE_URL } from '@/constants/constants';

import { Plugins, FilesystemDirectory, FilesystemEncoding } from '@capacitor/core';

const { Storage, Filesystem } = Plugins;

const rootUrl = BASE_URL;

function readStampFromUrl(url) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            resolve(e.target.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(url);
    });
}

export default {
    state: {
        stamps: [],
        stamps_ready: false,
        stamp_files: {},
        cached_stamps: [],
        all_cached_stamps: [],
        loaded_stamps: {},
        loading_stamps: false
    },

    mutations: {
        
        setStamps(state, data) {
            Vue.set(state, 'stamps', data);
            try {
                Storage.set({
                    key: 'stamps_list',
                    value: JSON.stringify(state.stamps)
                });
            } catch (e) {
                // console.error(e);
            }
        },

        addToCache(state, { id, media }) {
            Vue.set(state.loaded_stamps, id, media);
        },

        addToStampCache(state, stamp) {
            let current_cache = unionBy(state.all_cached_stamps, [ stamp ], 'id');
            Vue.set(state, 'all_cached_stamps', current_cache);
            try { 
                Storage.set({
                    key: 'all_cached_stamps',
                    value: JSON.stringify(state.all_cached_stamps)
                });
            } catch (e) {
                // console.error(e);
            }
        },

        setStampCache(state, data) {
            Vue.set(state, 'loaded_stamps', data);
        },
        
        setAllStampCache(state, data) {
            Vue.set(state, 'all_cached_stamps', data);
            try {
                Storage.set({
                    key: 'all_cached_stamps',
                    value: JSON.stringify(state.all_cached_stamps)
                });
            } catch (e) {
                // console.error(e);
            }
        },

        setStampsLoading(state, data) {
            Vue.set(state, 'loading_stamps', data);
        },
        
        setStampsReady(state, data) {
            Vue.set(state, 'stamps_ready', data);
        },
        
        updateStamp(state, data) {
            let current_cache = unionBy([ data ], state.stamps, 'id');
            Vue.set(state, 'stamps', current_cache);
            try {
                Storage.set({
                    key: 'stamps_list',
                    value: JSON.stringify(state.stamps)
                });
            } catch (e) {
                // console.error(e);
            }
        },

        updateStampCache(state, data) {
            let current_cache = unionBy([ data ], state.all_cached_stamps, 'id');
            Vue.set(state, 'all_cached_stamps', current_cache);
            try {
                Storage.set({
                    key: 'all_cached_stamps',
                    value: JSON.stringify(state.all_cached_stamps)
                });
            } catch (e) {
                console.error(e);
            }
        }
    
    },

    actions: {
        // Get
        getStampsList({ commit, dispatch }) {
            Storage.get({ key: 'stamps_list' }).then((response) => {
                let list = JSON.parse(response.value);
                if (list && list.length) {
                    commit('setStamps', list);
                }
            });
            dispatch('fetchStamps');
        },

        // Fetch
        async fetchStamps({ commit, rootState }) {
        
            const headers = { 'Authorization': rootState.authorization };
            const response = await axios.get(`${rootUrl}/account/annotations/stamps/2/`, { headers: headers });    
            
            if (response.status === 200) {
                const new_stamps = [];
                each(response.data, (stamp) => {
                    new_stamps.push({ id: stamp.id, label: stamp.label, media: stamp.stamp_url, filename: stamp.media, dirty: true, stamp_url: stamp.stamp_url  });
                });
                commit('setStamps', new_stamps);
            }

            if (response.status !== 200) {
                console.error('Could not fetch stamps from the API');
                console.error(response);
            }
        },

        async reloadStampCache({ commit }) {
            let new_cache = [];
            await Storage.get({ key: 'all_cached_stamps' }).then((response) => {
                new_cache = JSON.parse(response.value);
                commit('setAllStampCache', new_cache);
            });
            return new_cache;
        },

        // Fetch All 
        async fetchAllStamps({ commit, dispatch, rootState }) {
            
            let new_cache = await dispatch('reloadStampCache');
            if (new_cache === null) { new_cache = []; }
            
            const headers = { 'Authorization': rootState.authorization };
            const response = await axios.get(`${rootUrl}/account/annotations/stamps/`, { headers: headers });

            if (response.status === 200) {
                let needs_fetch = false;
                
                for (const index in response.data) {
                    const stamp = response.data[index];
                    const find_stamp = (element) => element.id === stamp.id;
                    const stamp_name = `stamp-${stamp.id}.png`;
                    let index = new_cache.findIndex(find_stamp);
                    
                    try {
                        await Filesystem.stat({ 
                            path: stamp_name,
                            directory:  FilesystemDirectory.Cache 
                        });
                    } catch (e) {
                        console.error(`Missing ${stamp_name}`); 
                        index = -1;
                    }
                    
                    if (index < 0) {
                        needs_fetch = true;
                        await commit('addToStampCache', { id: stamp.id, label: stamp.label, media: stamp.stamp_url, filename: stamp.media, dirty: true, stamp_url: stamp.stamp_url });
                    }
                }
                if (needs_fetch !== false) { await dispatch('fetchStampFiles'); }
            }

            if (response.status !== 200) {
                console.error('Could not fetch stamps from the API');
                console.error(response);
            }

            return new_cache;
        
        },

        // Clear
        clearStamps({ commit }) {
            commit('setStamps', []);
            commit('setStampCache', {});
            commit('setAllStampCache', {});
            commit('setStampsLoading', false);
            commit('setStampsReady', false);
        },

        async fetchStampFiles({ state, dispatch }) {
            
            let all_stamps_ready = true;
            
            console.info("Fetching stamps...");

            for (const index in state.all_cached_stamps) {
                const stamp = state.all_cached_stamps[index];
                const stamp_name = `stamp-${stamp.id}.png`;
                try {
                    await Filesystem.stat({ 
                        path: stamp_name,
                        directory:  FilesystemDirectory.Cache 
                    });
                    if (!stamp.media.startsWith('data')) {
                        await dispatch('fetchStampFile', stamp);
                        all_stamps_ready = false;
                    }
                } catch(e) {
                    all_stamps_ready = false;
                    await dispatch('fetchStampFile', stamp);
                }
            }
            
            Vue.set(state, 'stamps_ready', all_stamps_ready);
            
            return all_stamps_ready;
        
        },

        async fetchStampFile({ dispatch }, stamp) {
            let data;
            const stamp_name = `stamp-${stamp.id}.png`;

            try {
                await Filesystem.stat({ 
                    path: stamp_name,
                    directory:  FilesystemDirectory.Cache 
                });
                data = await dispatch('loadStampFromStorage', stamp);
            } catch (e) {
                
                const response = await fetch(stamp.stamp_url);
                console.error(`${stamp_name} was not in storage...`);

                if (response.ok) {
                    const data = await response.blob();
                    stamp.data = data;
                    await dispatch('saveStampToStorage', stamp);
                } else {
                    console.error(`Could not download ${stamp.url}...`);
                    return false;
                }
            }

            return data;
        },

        async loadAssetsForAnnotations({ commit, getters, dispatch }, annotations) {
            // Returns a stamp array for a given annotation set.
            let stamp_array = [];
            let seen_ids = [];
            
            for (const page of annotations) {
                for (const layer of page) {
                    if (layer.element === 'stamp') {
                        if (!seen_ids.includes(layer.stampId)) {
                            const index = getters.getStampCache.find(element => element.id === layer.stampId);
                            if (index) {
                                seen_ids.push(index.id);
                                const data = await dispatch('loadStampFromStorage',index);
                                const stamp = Object.assign({}, index);
                                stamp.media = data;
                                stamp_array.push(stamp);
                            }
                        }
                    }
                }
            }
            return stamp_array;
        },

        async loadStampFromStorage({ commit, dispatch }, stamp) {
            const stamp_name = `stamp-${stamp.id}.png`;

            try {

                let contents = await Filesystem.readFile({
                    path: stamp_name,
                    directory:  FilesystemDirectory.Cache,
                    encoding: FilesystemEncoding.UTF8
                });
    
                stamp.cache_name = stamp_name;
                stamp.dirty = false;
                
                commit('updateStamp', stamp);
                commit('updateStampCache', stamp);
                
                return contents.data;
            
            } catch (e) {
                console.error(`${stamp_name} is not in storage. Downloading...`);
                await dispatch('fetchStampFile', stamp);
            }

            return false;
        },

        async saveStampToStorage({ commit }, stamp) {
            const stamp_name = `stamp-${stamp.id}.png`;
            const data = await readStampFromUrl(stamp.data);
            
            await Filesystem.writeFile({
                path: stamp_name,
                data: data,
                directory:  FilesystemDirectory.Cache,
                encoding: FilesystemEncoding.UTF8
            });
            
            stamp.cache_name = stamp_name;
            stamp.dirty = false;
            await commit('updateStamp', stamp);
            await commit('updateStampCache', stamp);

            return stamp_name;
        }
    
    },

    getters: {
        
        getStamps: (state) => {
            return state.stamps;
        },

        getStampInCache: (state) => (id) => {
            return state.all_cached_stamps.find((stamp) => {
                return state.id === id;
            });
        },

        getStampCache: (state) => {
            return state.all_cached_stamps;
        },

        getStampsReady: (state) => {
            return state.stamps_ready;
        },

        getStampsLoading: (state) => {
            return state.loading_stamps;
        },

        getAllStampsLoaded: (state) => {
            return state.stamps_ready;
        },

        getStampCacheStatus: (state) => {
            return filter(state.all_cached_stamps, (stamp) => { !stamp.stamp_name; })
        },

        getStampsCached: (state) => {
            return filter(state.all_cached_stamps, (stamp) => { !!stamp.stamp_name; })
        }

    },
};